import { ChangeEvent, useState } from 'react'

import { ImageSchemaType, useImagesValidation } from '@/common/form/schema'

import UploadDropZone, {
  UploadDropZoneImageSize
} from '@/components/view/atoms/upload/UploadDropZone'

import FormDropZone from '@/components/container/form/widgets/FormDropZone'

interface Props {
  file?: File
  image?: ImageSchemaType
  fromUrl?: boolean
  imageSize?: UploadDropZoneImageSize
  onUploadFiles(files: File[]): void
  onDelete?(): void
  onlyImageFile?: boolean
  disabled?: boolean
}

const FormFileUpload = ({
  file,
  image,
  fromUrl,
  imageSize,
  onUploadFiles,
  onDelete,
  onlyImageFile = false,
  disabled = false
}: Props) => {
  const { validate } = useImagesValidation()

  const [dragging, setDragging] = useState<boolean>(false)

  const onUploadFile = (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.currentTarget.files
    if (!files || files?.length === 0) return
    if (onlyImageFile && !validate(Array.from(files))) {
      return
    }
    onUploadFiles(Array.from(files))
  }

  const filePath = image ? undefined /*imageModelSchemaPath(image)*/ : undefined

  return (
    <FormDropZone
      className={'w-full'}
      onUploadFiles={(files) => {
        onUploadFiles(files)
        setDragging(false)
      }}
      onDragEnter={() => setDragging(true)}
      onDragLeave={() => setDragging(false)}
    >
      <UploadDropZone
        buttonText={
          fromUrl ? '新規アップロード' : file ? 'ファイルを変更する' : 'ファイルを追加する'
        }
        fileName={
          file
            ? file.name
            : image?.stored
              ? image.stored.imagePath
              : image?.uploading
                ? image.uploading.name
                : undefined
        }
        filePath={filePath}
        fromUrl={!(file || image) && fromUrl}
        onChange={onUploadFile}
        onDelete={onDelete}
        dragging={dragging}
        imageSize={imageSize}
        onlyImageFile={onlyImageFile}
        disabled={disabled}
      />
    </FormDropZone>
  )
}

export default FormFileUpload
